import { Button } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import EntryImage from '../../molecules/entry-image.component';
import EntryLabel from '../../molecules/entry-label.component';
import EntryTitle from '../../molecules/entry-title.component';
import LoadingScreen from '../../molecules/loading-screen.component';
import { RecruitEntryService } from '../../services/recruit-entry/recruit-entry.service';
import { EntryType, PickerOptionItem } from '../types';
import EntryContext from './entry-context';
import { expandPicklist } from './entry-utils';

interface EntryConfirmProp {
  entryType: EntryType,
}
export default function EntryConfirm({
  entryType,
}: EntryConfirmProp) {
  const history = useHistory();
  // @ts-ignore
  const { jobType } = useParams();
  const { data, picklist } = useContext(EntryContext);
  const [loading, setLoading] = useState(false);
  const [genderTypes, setGenderTypes] = useState<PickerOptionItem[]>([]);
  const [howToKnowTypes, setHowToKnowTypes] = useState<PickerOptionItem[]>([]);
  const [desiredJobTypes, setDesiredJobTypes] = useState<PickerOptionItem[]>([]);
  
  useEffect(() => {
    if(!data || Object.keys(data).length === 0) {
      history.replace(`/entry/${entryType}`);

      return ;
    }
    const { genderTypes, howToKnowTypes, desiredJobTypes } = expandPicklist(picklist!);
    
    setGenderTypes(genderTypes);
    setHowToKnowTypes(howToKnowTypes);
    setDesiredJobTypes(desiredJobTypes);

    const cleanup = () => {
    }
    return cleanup;
    
  }, []);

  const onComplete = async () => {
    setLoading(true);
    try {
      await new RecruitEntryService().create(data);

    } finally {
      setLoading(false);
    }
    history.replace(`/entry/${entryType}/${jobType}/complete`);
  }

  const onBack = () => {
    history.goBack();
  }

  return (
    <>
      <div className="entry">
        {EntryTitle({entryType})}

        <div className="entry-confirm">
          {EntryLabel({
            label: '希望職種',
            value: data?.desiredJobType,
            optionItems: desiredJobTypes,
          })}
          {EntryLabel({
            label: '氏名',
            value: data?.fullName,
          })}
          {EntryLabel({
            label: 'フリガナ',
            value: data?.fullNameKana,
          })}
          {EntryLabel({
            label: '電話番号',
            value: data?.phone,
          })}
          {EntryLabel({
            label: 'メールアドレス',
            value: data?.email,
          })}
          {EntryLabel({
            label: '住所',
            value: data?.address,
            visible: entryType === 'recruit',
          })}
          {EntryLabel({
            label: '年齢',
            value: data?.age,
            visible: entryType === 'recruit',
          })}
          {EntryLabel({
            label: '性別',
            value: data?.gender,
            visible: entryType === 'recruit',
            optionItems: genderTypes,
          })}
          {EntryImage({
            label: '顔写真',
            value: data?.photo,
            visible: entryType === 'recruit',
          })}
          {EntryLabel({
            label: 'HOSHINOを知ったきっかけ',
            value: data?.howToKnow,
            optionItems: howToKnowTypes,
          })}
          {EntryLabel({
            label: '最終学歴',
            value: data?.career,
            visible: entryType === 'recruit',
          })}
          {EntryLabel({
            label: '資格',
            value: data?.qualified,
            visible: entryType === 'recruit',
          })}
          {EntryLabel({
            label: '志望動機',
            value: data?.motivation,
            visible: entryType === 'recruit',
          })}
          {EntryLabel({
            label: '功績',
            value: data?.achievement,
            visible: entryType === 'recruit',
          })}
          {EntryLabel({
            label: 'コミットメント',
            value: data?.commitment,
            visible: entryType === 'recruit',
          })}
          {EntryImage({
            label: '職務経歴書',
            value: data?.jobHistory,
            visible: entryType === 'recruit',
            preview: false,
          })}

          <p className="attention">上記内容でお間違えないことを確認の上、確定ボタンを押してください。</p>

          <div className="entry-buttons">
            <Button
              type="button"
              className="entry-button"
              variant="contained"
              color="primary"
              onClick={onComplete}
            >
              確定
            </Button>
            <Button
              type="button"
              className="entry-button"
              variant="contained"
              onClick={onBack}
            >
              戻る
            </Button>
          </div>
        </div>
      </div>
      {LoadingScreen({ loading })}
    </>
  );
}